module.exports = __webpack_public_path__ + "img/kiwi.36d3673f.svg";